import * as types from './constants';

// Kept apart from creatorDetails, which the Creator page loads and resets on its own.
const initialState = {
  data: {
    uuid: '',
    name: '',
    rank: ''
  },
  loading: false,
  errors_api: {}
};

const actions = {
  [types.GET_CHAT_CREATOR_DETAILS_REQUEST]: state => ({
    ...state,
    loading: true,
    data: initialState.data,
    errors_api: {}
  }),

  [types.GET_CHAT_CREATOR_DETAILS_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),

  [types.GET_CHAT_CREATOR_DETAILS_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  [types.GET_CHAT_CREATOR_DETAILS_RESET]: () => ({ ...initialState })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
